import { useTranslation } from 'react-i18next';
import { Heading } from '@ifrc-go/ui';

import fourHundredFourImage from '#assets/content/four_hundred_four.svg';
import fourHundredFourBackgroundImage from '#assets/content/four_hundred_four_background.svg';
import Link from '#components/Link';
import Page from '#components/Page';

import styles from './styles.module.css';

function FourHundredFour() {
  const { t } = useTranslation();

  return (
    <Page
      title={t("fourHundredFour.title")}
      mainSectionClassName={styles.main}
      mainSectionContainerClassName={styles.mainContainer}
    >
      <div className={styles.backgroundLayer}>
        <img
          src={fourHundredFourBackgroundImage}
          className={styles.image}
          alt={t("fourHundredFour.fourHundredFourBackground")}
        />
      </div>
      <div className={styles.fourHundredFourHeading}>
        <img
          src={fourHundredFourImage}
          className={styles.image}
          alt={t("fourHundredFour.fourHundredFourImage")}
        />
      </div>
      <div className={styles.content}>
        <Heading
          level={1}
        >
          {t("fourHundredFour.headingOpps")}
        </Heading>
        <div className={styles.description}>
        {t("fourHundredFour.pageWanderedOff")}
        </div>
        <div className={styles.description}>
          {t("fourHundredFour.goBackHome")}
        </div>
      </div>
      <Link
        to="/"
        variant="primary"
      >
        {t("fourHundredFour.backToHome")}
      </Link>
    </Page>
  );
}

export default FourHundredFour;
